<template>
    <div>
        <div class="absolute left">
            <MaintenanceNotification />
        </div>
        <div class="absolute right">
            <Version v-if="false" />
        </div>
    </div>
</template>

<style scoped>
.absolute {
    position: fixed;
    bottom: 2rem;
}

.left {
    left: 2rem;
}

.right {
    right: 2rem;
}
</style>

<script>
import MaintenanceNotification from "./MaintenanceNotification.vue";
import Version from "./Version.vue";

export default {
    name: "AppFooter",
    components: {
        MaintenanceNotification,
        Version,
    },
};
</script>
